// extracted by mini-css-extract-plugin
export var actions = "Notification-module--actions--4538a";
export var animate = "Notification-module--animate--eb543";
export var bcBtn = "Notification-module--bc-btn--137bb";
export var bcCartHeader = "Notification-module--bc-cart-header--bd22c";
export var bcCartItem = "Notification-module--bc-cart-item--eb99b";
export var bcCartItemMeta = "Notification-module--bc-cart-item-meta--90a72";
export var bcCartItemQuantity = "Notification-module--bc-cart-item-quantity--4438b";
export var bcCartItemTotalPrice = "Notification-module--bc-cart-item-total-price--f878f";
export var bcCartItem__productTitle = "Notification-module--bc-cart-item__product-title--7f5e5";
export var close = "Notification-module--close--8c76a";
export var container = "Notification-module--container--7036e";
export var content = "Notification-module--content--b332b";
export var fadeIn = "Notification-module--fadeIn--8a376";
export var icon = "Notification-module--icon--e75d6";
export var message = "Notification-module--message--17cad";
export var messageWrapper = "Notification-module--messageWrapper--6c2fd";
export var notification = "Notification-module--notification--1aa63";
export var notify = "Notification-module--notify--90c04";
export var text = "Notification-module--text--f26ab";
export var title = "Notification-module--title--06239";